import { makeRequest } from "../shared/request-service";
import { METHODS } from "../shared/requests.constants";
import { AUTH_ENDPOINTS } from "./auth.constant";

export const checkAutoLogin = () => {
  try {
    const jwt = localStorage.getItem("accesstoken");
    if (!jwt) return false;
    const decodedJwt = JSON.parse(atob(jwt.split(".")[1]));
    if (decodedJwt.expiry * 1000 < Date.now()) return false;
    return true;
  } catch (e) {
    return false;
  }
};

export const registerUser = async (payload: any) => {
  try {
    const response = await makeRequest(
      AUTH_ENDPOINTS.REGISTER,
      METHODS.POST,
      payload
    );
    console.log(response);
    if (!response) {
      throw new Error(`Something wen't wrong during resgistration!`);
    }
    return response.data;
  } catch (error) {
    console.error(`registerUser > ${error.toString()}`);
    throw error;
  }
};

export const resendOTP = async (payload: any) => {
  try {
    const response = await makeRequest(
      AUTH_ENDPOINTS.RESEND_OTP,
      METHODS.POST,
      payload
    );
    console.log(response);
    if (!response) {
      throw new Error(`Something wen't wrong during sendign otp!`);
    }
    return response.data;
  } catch (error) {
    console.error(`resending otp > ${error.toString()}`);
    throw error;
  }
};

export const loginUser = async (payload: any) => {
  try {
    
    const response = await makeRequest(
      AUTH_ENDPOINTS.LOGIN,
      METHODS.POST,
      payload
    );
    
    if (!response) {
      throw new Error(`Something wen't wrong during login!`);
    }
    return response.data;
  } catch (error) {
    console.error(`registerUser > ${error.toString()}`);
    throw error;
  }
};

export const verifyEmailService = async (payload: any) => {
  try {
    const response = await makeRequest(
      AUTH_ENDPOINTS.VERIFY_EMAIL,
      METHODS.POST,
      payload
    );
    
    if (!response) {
      throw new Error("Something went wrong during email verification!");
    }
    console.log(response.data);
    return response.data;

    
  } catch (error) {
    console.error(`verifyEmailService > ${error.toString()}`);
    throw error;
  }
};

export const forgetPassword = async (payload: any) => {
  try {
    const response = await makeRequest(
      AUTH_ENDPOINTS.FORGET_PASSWORD,
      METHODS.POST,
      payload
    );
    if (!response) {
      throw new Error(`Something wen't wrong during login!`);
    }
    return response.data;
  } catch (error) {
    console.error(`registerUser > ${error.toString()}`);
    throw error;
  }
};




export const resetPassword = async (payload: any) => {
  try {
    const response = await makeRequest(
      AUTH_ENDPOINTS.RESET_PASSWORD,
      METHODS.POST,
      payload 
    );
    if (!response) {
      throw new Error(`Something went wrong during password reset!`);
    }
    console.log("RESPONSE: " , response.data)
    return response.data;
  } catch (error) {
    console.error(`resetPassword > ${error.toString()}`);
    throw error;
  }
};


export const GoogleAuth = async () => {
  try {
    const response = await makeRequest(
      AUTH_ENDPOINTS.GOOGLE_AUTH,
      METHODS.GET,
    );
    if (!response) {
      throw new Error(`Something wen't wrong during resgistration!`);
    }
    console.log("GOOGL AUTH RESPONSE: " ,response);
    return response.data;
  } catch (error) {
    console.error(`registerUser > ${error.toString()}`);
    throw error;
  }
};

export const FbAuth = async () => {
  try {
    const response = await makeRequest(
      AUTH_ENDPOINTS.FB_AUTH,
      METHODS.GET,
    );
    if (!response) {
      throw new Error(`Something wen't wrong during resgistration!`);
    }
    console.log("FB AUTH RESPONSE: " ,response);
    return response.data;
  } catch (error) {
    console.error(`registerUser > ${error.toString()}`);
    throw error;
  }
};